import axios from 'axios'
import _debounce from 'lodash/debounce'
import _filter from 'lodash/filter'
import _includes from 'lodash/includes'
import { mapState, mapMutations } from 'vuex'

export const productFilter = {
  props: {
    isOnProductDetailPage: Boolean,
    totalFiltersActive: Number
  },
  data: function () {
    return {
      filtersDropdown: null,
      nothingFound: false,
      results: null,
      search: '',
      searching: false
    }
  },
  computed: {
    ...mapState(
      'mockData',
      [
        'productFilters'
      ]
    ),
    url: function () {
      return `${this.$domain}/product_filters`
    }
  },
  watch: {
    search: function () {
      this.startSearch()
    }
  },
  methods: {
    ...mapMutations(
      'ui',
      [
        'filtersActiveProductsPageAdd',
        'filtersActiveProductDetailPageAdd'
      ]
    ),
    addActiveFilter (event, filter) {
      if (this.isOnProductDetailPage) {
        this.filtersActiveProductDetailPageAdd(filter)
      } else {
        this.filtersActiveProductsPageAdd(filter)
      }

      // NOTE
      // component that uses this mixin
      // must define this function
      this.closeDropdown()
    },
    loadSearch () {
      this.searching = true

      if (this.possibleFilters) {
        this.filtersDropdown = this.possibleFilters
        return true
      }

      const params = {
        filter_type__startswith: this.filterType,
        search: this.search,
        limit: 10
      }

      return axios({
        method: 'get',
        url: this.url,
        params: params
      })
      .then((response) => {
        this.searching = false

        // let data = null

        // if (this.filterType === 'tag') {
        //   data = this.productFilters.tags
        // } else if (this.filterType === 'option') {
        //   data = this.productFilters.options
        // } else if (this.filterType === 'product') {
        //   data = this.productFilters.products
        // }

        let productFilters = response.data['product_filters']

        const totalFilters = productFilters.length
        // const totalFilters = data.length

        // this is used on the Product Detail page
        // this restricts the results to the ones
        // possible for that particular product
        if (this.possibleFilters) {
          productFilters = _filter(productFilters, (filter) => {
            return _includes(this.possibleFilters, filter.id)
          })
        }

        if (totalFilters > 0) {
          this.filtersDropdown = productFilters
          // this.filtersDropdown = data
        } else {
          this.filtersDropdown = null
          this.nothingFound = true
        }
      })
      .catch((error) => {
        this.searching = false
        console.log(error)
      })
    },
    resetSearch () {
      this.nothingFound = false
      this.filtersDropdown = null
      this.searching = false
    },
    searchDebounce: _debounce(function () {
      if (this.search.length > 0) {
        this.loadSearch()
      } else {
        this.resetSearch()
      }
    }, 500),
    startSearch: function () {
      if (this.search.length > 0) {
        this.searching = true
      }

      this.searchDebounce()
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/mixins/productFilter.js